import {create} from 'zustand'

interface FilialState {
  filial: string
  definirFilial: (filial: string) => void
}

const FILIAL_INICIAL = '1'

export const useFilialStore = create<FilialState>(set => ({
  filial: FILIAL_INICIAL,
  definirFilial: filial => set({filial}),
}))
